import { getPollingPages } from '../utils/utils';

export const initialState = {
	page: 1,
	minPage: 1,
	pages: 1,
	total: 0,
};

export const pagination = ( state = initialState, action ) => {
	switch ( action.type ) {
		case 'GET_ENTRIES':
			return {
				...state,
				page: action.page,
			};

		case 'GET_ENTRIES_SUCCESS':
			return {
				...state,
				pages: Math.max( action.payload.pages, 1 ),
				page: action.payload.page,
				// A replace resets the loaded window: this page is now both the first
				// and last page on screen. Jumping to a key event can land past page 1.
				minPage: action.payload.page,
				total: action.payload.total || 0,
			};

		// Infinite scroll appended an older page: `page` tracks the deepest page
		// loaded, while minPage stays put because the earlier pages are still shown.
		case 'GET_ENTRIES_APPEND_SUCCESS':
			return {
				...state,
				pages: Math.max( action.payload.pages, 1 ),
				page: action.payload.page,
				total: action.payload.total || state.total,
			};

		case 'MERGE_POLLING_INTO_ENTRIES':
			// Count new entries from payload (entries with type 'new')
			const newCount = action.payload.filter(
				( e ) => e.type === 'new'
			).length;
			return {
				...state,
				pages: action.pages,
				total: state.total + newCount,
			};

		case 'CREATE_ENTRY_SUCCESS':
			return {
				...state,
				total: state.total + 1,
			};

		case 'DELETE_ENTRY_SUCCESS':
			return {
				...state,
				total: Math.max( 0, state.total - 1 ),
			};

		case 'POLLING_SUCCESS':
			return {
				...state,
				pages: action.renderNewEntries
					? getPollingPages( state.pages, action.payload.pages )
					: state.pages,
			};

		default:
			return state;
	}
};
